'use client';
import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Link,
  UnorderedList,
  ListItem,
  Center,
  Box,
  Flex,
} from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { setStateValue } from '@/app/redux/slices/configGymSlice';
import moment from 'moment';
import weeksData from '/public/data/gym/weeksSchedule.json'; // database of scheuled weeks adn run areas
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faSubtitles } from '@fortawesome/pro-solid-svg-icons';
import useCreateBasicGymData from '/app/hooks/gym/useCreateBasicGymData';
const title = {
  padding: { base: '6vw 6vw 0', md: '2vw 2vw 0' },
  textAlign: 'center',
  width: '100%',
};
const textBody = {
  padding: '1vw 0',
};
const buttonNext = {
  width: '48%',
  borderRadius: { base: '4vw', md: '3vw' },
  bg: '#0cc6de',
  color: 'white',
  fontSize: { base: '4vw', md: '1vw' },
  fontWeight: 600,
  padding: { base: '2vw 0', md: '1.5vw 0' },
  _hover: {
    cursor: 'pointer',
    bg: '#0cc6de80',
  },
};
const buttonPrevious = {
  width: '48%',
  borderRadius: { base: '4vw', md: '3vw' },
  bg: '#333333',
  color: 'white',
  fontSize: { base: '4vw', md: '1vw' },
  fontWeight: 600,
  padding: { base: '2vw 0', md: '1.5vw 0' },
  _hover: {
    cursor: 'pointer',
    bg: '#666666',
  },
};

export default function SurveyPending({ isOpen, onClose }) {
  const dispatch = useDispatch();
  const createBasicGymData = useCreateBasicGymData();
  const survey = useSelector((state) => state.gym.survey); // Select the survey array from Redux state
  const vanRun = useSelector((state) => state.basket.optimoData.customField3);
  const optimoDate = useSelector(
    (state) => state.basket.optimoData.customField3
  );
  const [isSlotPendingModalOpen, setIsSlotPendingModalOpen] = useState(false);
  const [firstMatch, setFirstMatch] = useState({});

  const handleAgree = (booking) => {
    createBasicGymData();
    dispatch(
      setStateValue({ key: 'requestedSlotID', value: firstMatch.uniqueID })
    );
    dispatch(
      setStateValue({ key: 'bookingWeek', value: firstMatch.textDates })
    );
    dispatch(setStateValue({ key: 'nearest', value: firstMatch.region }));
    dispatch(
      setStateValue({ key: 'optimoDate', value: firstMatch.optimoDates.from })
    );
    if (booking === 'booked') {
      dispatch(setStateValue({ key: 'bookingCheck', value: true }));
    } else {
      dispatch(setStateValue({ key: 'bookingCheck', value: false }));
    }
  };

  useEffect(() => {
    const nextWeeks = getNextNineWeeks(weeksData);
    //console.log('nextWeeks ', nextWeeks);
    //console.log('vanRun ', vanRun);
    const match = nextWeeks.find((week) => week.region === vanRun);
    if (match) {
      setFirstMatch(match); // Safely update state
    } else {
      setFirstMatch(null); // Ensure state is cleared if no match
    }
    //setNextWeeks(nextWeeks);
    //enrichWeeks(nextWeeks, bookings);
  }, [vanRun]);
  function getNextNineWeeks(weeksData) {
    const today = moment().format('YYYY-MM-DD');
    const filteredWeeks = weeksData.filter((week) =>
      moment(week.startDate, 'YYYY-MM-DD').isAfter(today)
    );
    return filteredWeeks.slice(0, 9);
  }
  if (firstMatch) {
    //console.log('match ', firstMatch);
  }

  const weekCommence = {
    width: '100%',
    padding: '1vw',
    color: 'Maroon',
    fontWeight: '600',
  };
  const formIcon = {
    width: 'auto',
    color: '	#505050',
    display: 'flex',
    margin: '0 1vw',
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="4xl">
      <ModalOverlay />
      <ModalContent
        padding={{ base: '5vw', md: '1.5vw' }}
        borderRadius={{ base: '4vw', md: '2vw' }}
      >
        <ModalHeader {...title} fontSize={{ base: '5vw', md: '1.6vw' }}>
          Survey / Installation Booking.
        </ModalHeader>
        <ModalCloseButton
          onClick={() => {
            handleAgree();
          }}
        />
        <ModalBody>
          <Text {...textBody}>
            We've found the earliest available booking date based on your
            postcode. If this date works for you, simply press the 'Book Now'
            button below to proceed to payment and secure your booking. We'll
            take care of the rest!
          </Text>
          <Center {...weekCommence}>
            Week of : {firstMatch && firstMatch.textDates}
          </Center>
          <Text {...textBody}>
            Once your booking is confirmed, we'll finalise the schedule at least
            3 days before your designated slot. One of our team members will
            personally get in touch to provide the exact time and date for your
            survey or installation.
          </Text>
          <Text {...textBody}>
            Prefer a different date? No worries! Just fill out our contact form
            or drop us an email, and we'll happily find an alternative that
            works for you.
          </Text>

          <Flex>
            <Center {...formIcon}>
              <FontAwesomeIcon icon={faSubtitles} />
            </Center>

            <Box
              as="button" // Makes the list item clickable
              onClick={() => {
                onClose(); // Close the modal
                window.scrollTo({
                  top: document.body.scrollHeight, // Scroll to the bottom of the page
                  behavior: 'smooth', // Smooth scrolling effect
                });
              }}
            >
              Contact Form.
            </Box>
          </Flex>
          <Flex marginBottom="3vw">
            <Flex>
              <Center {...formIcon}>
                <FontAwesomeIcon icon={faEnvelope} />
              </Center>

              <Link href="mailto:sales@mirrorworld.co.uk" color="blue.500">
                sales@mirrorworld.co.uk
              </Link>
            </Flex>
          </Flex>
        </ModalBody>

        <ModalFooter
          display="flex"
          justifyContent="center"
          alignItems="center"
          padding="0 1vw 2vw"
          gap="1vw"
        >
          <Button
            {...buttonPrevious}
            mr={3}
            onClick={() => {
              handleAgree('pending');
              onClose();
            }}
          >
            Cancel
          </Button>
          <Button
            {...buttonNext}
            onClick={() => {
              handleAgree('booked');
              onClose();
            }}
          >
            Book Now
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
